module.exports = __webpack_public_path__ + "img/mobileapplication8.c32099d1.png";